import React, { Component } from 'react'

class GameOver extends Component {
  render() {
    return (
      <div
        className="game__game-over-container"
        style={{ display: this.props.context.state.gameOver }}
      >
        <div
          className="game__game-over"
          style={{ display: this.props.context.state.gameOver }}
        >
          <h1 className="game__game-over-header">
            <span
              style={{
                fontSize: '10px',
                lineHeight: '1.2',
                maxWidth: '110px',
                display: 'inline-block',
              }}
            >
              our new single is called
            </span>
            <br />
            GAME OVER
          </h1>
          <p className="game__you-scored">
            You scored {this.props.context.state.score}/25
          </p>
        </div>

        <span>
          ▻
          <a
            href="https://www.youtube.com/channel/UCieTJ3xX4_gDfsTJNS_T6ow"
            target="_blank"
            rel="noopener noreferrer
        "
          >
            {'Watch the music video'}
          </a>
          ◅
        </span>
        <br />
        <span>
          ▻
          <a
            href="https://open.spotify.com/artist/6TNEud8QNzjmtkZSCSW85v?si=R-aJcEvPSMOhRAmQTS0Ebg&dl_branch=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            {'Add it to your Spotify playlists'}
          </a>
          ◅
        </span>
        <br />
        <span>
          ▻
          <a
            href="https://www.instagram.com/__majorelleblue/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {'Check it out on Instagram '}
          </a>
          ◅
        </span>
      </div>
    )
  }
}

export default GameOver



// WEBPACK FOOTER //
// ./src/components/GameOver.js